import React from 'react';

import type { IconBaseProps, IconType } from 'react-icons';

// A single-color, fillable version of the SearchPilot mark.
// The SVG paths are derived from static_src/images/SearchPilot-mark.svg
// and adapted to inherit color via currentColor.
const SearchPilotMark: IconType = ({
  className,
  style,
  ...props
}: IconBaseProps) => {
  return (
    <svg
      viewBox="0 0 154.615 127.342"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
      fill="currentColor"
      width="1em"
      height="1em"
      className={className}
      style={style}
      {...props}
    >
      <g>
        <g>
          <path d="M75.226,75.754c6.679-6.676,6.679-17.496,0-24.156L34.467,10.825c-6.676-6.667-17.489-6.667-24.152,0l0,0 c-6.676,6.673-6.676,17.489,0,24.153l40.762,40.775C57.736,82.414,68.553,82.414,75.226,75.754L75.226,75.754z" />
          <path d="M10.314,92.364l40.762-40.775c0.163-0.168,0.99-0.935,1.169-1.088 c11.716-11.468,1.079-20.805,1.079-20.805L75.17,51.545c0.029,0.023,0.042,0.035,0.056,0.053c0.026,0.013,0.026,0.042,0.059,0.059 l0.205,0.205h-0.042c6.428,6.682,6.37,17.295-0.221,23.893l-40.759,40.759c-6.676,6.673-17.489,6.673-24.152,0 C3.639,109.84,3.639,99.03,10.314,92.364z" />
          <path d="M144.189,75.754c6.676-6.676,6.676-17.496,0-24.156l-40.759-40.772c-6.676-6.667-17.496-6.667-24.159,0 l0,0c-6.676,6.673-6.676,17.489,0,24.153l40.769,40.775C126.7,82.414,137.514,82.414,144.189,75.754L144.189,75.754z" />
          <path d="M79.272,92.364l40.769-40.775c0.16-0.168,0.994-0.935,1.169-1.088 c11.716-11.468,1.082-20.805,1.082-20.805l21.839,21.849c0.029,0.023,0.049,0.035,0.059,0.053 c0.029,0.013,0.029,0.042,0.055,0.059l0.206,0.205h-0.042c6.431,6.682,6.373,17.295-0.218,23.893l-40.759,40.759 c-6.676,6.673-17.496,6.673-24.159,0C72.596,109.84,72.596,99.03,79.272,92.364z" />
        </g>
      </g>
    </svg>
  );
};

export default SearchPilotMark;
